import { TicketApprover } from "../../model/ticketEasy/ticketApprover/TicketApprover";

export class ApproverCommand {
    approver: TicketApprover;

    constructor(approver: TicketApprover) {
        this.approver = approver;
    }
}



